import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IIdEntity } from '../interfaces/models/iid-entity';
import { AppSettings } from '../models/appsettings';
import { EntityState } from '../models/enums';
import { EventsService } from '../services/events.service';
import { ModelBaseService } from '../services/model-base.service';
import { UserContextService } from '../services/user-context.service';
import { VisualCmptRoleBaseComponent } from './visual-cmpt-roles-base.component';

@Component({
    template: '',
    standalone: false
})

export abstract class ModelFormComponent<T extends IIdEntity<number>> extends VisualCmptRoleBaseComponent {
  public isEditable = true;
  public isAuthor = false;  
  public model: T = { Id: 0 } as T;
  suggestionsRowsPerDdl: number = AppSettings.suggestionsRowsPerDdl;  

  constructor(
    protected events: EventsService,
    protected modelSvc: ModelBaseService<T>,
    protected userContextSvc: UserContextService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected location: Location) {

    super(events, userContextSvc, router, route, location);
  }

  ngOnInit() {
    super.ngOnInit();

    let queryIdStr = this.route.snapshot.paramMap.get('id');

    if (queryIdStr) {
      let qId: number = parseInt(queryIdStr);
      if (qId > 0)
        this.model.Id = qId;
      else
        this.model.State = EntityState.New;
    }
  }

  loadModel(modelId: number = this.model.Id): Promise<any> {
    if (this.loading || modelId < 1) {
      return new Promise((resolve) => { resolve(null); });
    }
    this.loading = true;
    return this.modelSvc.getById(modelId).toPromise()
      .then((x) => { return this.handleLoadModelSuccess(x); })
      .catch((err) => { return this.handleLoadError(err); });
  }

  handleLoadModelSuccess(res: T) {
    this.model = res;
    this.model.State = EntityState.View;
    this.onInitialDataLoadingComplete();
    return Promise.resolve(res);
  }

  getNullResolvedPromise(): Promise<any> {
    return new Promise((resolve) => { resolve(null); });
  }

  isNewModel(): boolean {
    return this.model.Id < 1;
  }
}
